import { useEffect, useState } from "react";
import { MapPin, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Panel } from "@/components/common";
import { api, errMsg } from "@/lib/api";

export function LocationsPanel() {
  const [items, setItems] = useState([]);
  const [f, setF] = useState({ name: "", address: "" });
  const load = () => api.get("/locations").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/admin/locations", f); setF({ name: "", address: "" }); toast.success("Sede aggiunta"); load(); } catch (e2) { toast.error(errMsg(e2)); }
  };
  const del = async (id) => {
    try { await api.delete(`/admin/locations/${id}`); load(); } catch (e2) { toast.error(errMsg(e2)); }
  };
  return (
    <Panel title="Sedi e punti vendita" testId="locations-panel">
      <div className="space-y-3 p-5">
        <form onSubmit={add} className="flex flex-wrap gap-2">
          <Input className="w-48" placeholder="Nome sede" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} required minLength={2} data-testid="location-name-input" />
          <Input className="min-w-[200px] flex-1" placeholder="Indirizzo (opzionale)" value={f.address} onChange={(e) => setF({ ...f, address: e.target.value })} data-testid="location-address-input" />
          <Button type="submit" data-testid="location-add-button"><Plus className="mr-1.5 h-4 w-4" />Aggiungi</Button>
        </form>
        {items.length === 0 ? <p className="text-sm text-muted-foreground">Nessuna sede. Aggiungile per assegnarle ai dipendenti e ai responsabili.</p> : (
          <ul className="divide-y rounded-md border">
            {items.map((l) => (
              <li key={l.id} className="flex items-center gap-3 px-3 py-2 text-sm" data-testid={`location-row-${l.id}`}>
                <MapPin className="h-4 w-4 text-primary" />
                <span className="flex-1"><span className="font-medium">{l.name}</span>{l.address && <span className="block text-xs text-muted-foreground">{l.address}</span>}</span>
                <Button size="icon" variant="ghost" className="h-8 w-8 text-destructive" onClick={() => del(l.id)} aria-label="Elimina sede" data-testid={`location-delete-${l.id}`}><Trash2 className="h-4 w-4" /></Button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </Panel>
  );
}
